<template>
    <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12.5" cy="12" r="12" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5 0C5.87097 0 0.5 5.37097 0.5 12C0.5 18.629 5.87097 24 12.5 24C19.129 24 24.5 18.629 24.5 12C24.5 5.37097 19.129 0 12.5 0ZM12.5004 22.4516C6.73754 22.4516 2.04883 17.7629 2.04883 12C2.04883 6.23705 6.73754 1.54834 12.5004 1.54834C18.2633 1.54834 22.9521 6.23705 22.9521 12C22.9521 17.7629 18.2633 22.4516 12.5004 22.4516ZM12.5 17.4195C14.1887 17.4195 15.7807 16.6743 16.8645 15.3775C17.1404 15.0485 17.6291 15.0049 17.9581 15.2759C18.2871 15.5469 18.3307 16.0356 18.0549 16.3646C16.6758 18.0195 14.6484 18.9679 12.5 18.9679C10.3516 18.9679 8.32422 18.0195 6.95003 16.3695C6.67422 16.0404 6.71777 15.5566 7.0468 15.2808C7.371 15.0049 7.8597 15.0485 8.13551 15.3775C9.21938 16.6743 10.8113 17.4195 12.5 17.4195ZM8.62944 11.2258C9.48589 11.2258 10.1778 10.5338 10.1778 9.67739C10.1778 8.82094 9.48589 8.129 8.62944 8.129C7.77299 8.129 7.08105 8.82094 7.08105 9.67739C7.08105 10.5338 7.77299 11.2258 8.62944 11.2258ZM17.919 9.67739C17.919 10.5338 17.2271 11.2258 16.3707 11.2258C15.5142 11.2258 14.8223 10.5338 14.8223 9.67739C14.8223 8.82094 15.5142 8.129 16.3707 8.129C17.2271 8.129 17.919 8.82094 17.919 9.67739Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "SmileIcon",
};
</script>
